import React, { useContext } from 'react'
import styles from './ChoicesButton.module.css'
import { StepContext } from '../../../Steps/StepContainer'
import { ChoicesButtonProps } from './types'

export const ChoicesButton = ({
    imageSrc,
    imageAlt = '',
    text,
    formKey,
    formValue,
    displayFormKey,
    displayFormValue,
    dataClickLabel,
}: ChoicesButtonProps) => {
    const {
        handleNext,
        setFormValue,
        updateUserResume,
        setDisplayValue,
        stepBoolean,
        formState,
    } = useContext(StepContext)

    const isSelected = Array.isArray(formKey)
        ? formState.userResumesAttributes[0][formKey[1]] === formValue[1]
        : formState[formKey] === formValue

    const handleFormUpdate = () => {
        if (
            Array.isArray(formKey) &&
            Array.isArray(formValue) &&
            formKey[0] === 'userResumesAttributes'
        ) {
            updateUserResume(formValue[0], formKey[1], formValue[1])
            return
        }
        setFormValue(formKey, formValue)
    }

    const handleSpecialCases = () => {
        if (formValue === 'resignation') {
            stepBoolean.step11 = false
            return
        }

        if (formValue === 'tenure') {
            formState.userResumesAttributes[0].workEndDateYear = null
            formState.userResumesAttributes[0].workEndDateMonth = null
        }
    }

    const handleClick = () => {
        setDisplayValue(displayFormKey, displayFormValue)
        handleFormUpdate()
        handleSpecialCases()
        handleNext()
    }

    return (
        <button
            className={`${styles.wrapper} ${isSelected ? styles.selected : ''}`}
            onClick={handleClick}
            data-click-label={dataClickLabel}
        >
            <div>
                <img
                    src={imageSrc}
                    alt={imageAlt}
                    className={styles.ChoicesButtonImage}
                />
            </div>
            <p className={styles.text}>{text}</p>
        </button>
    )
}
